import { FormControl, FormHelperText, FormLabel, Spinner, Textarea } from "@chakra-ui/react";
import { useDebouncedSave } from "../useDebouncedSave";

interface Props {
  label: string;
  name: string;
  helperText: string;
  errorMessage: string | undefined;
  onChange: (value: string) => void;
  debouncedOnChangeHandler?: (value: string) => Promise<void>;
  value: string;
  isLoading: boolean;
  required?: boolean;
}

export const TextAreaInput = ({
  name,
  label,
  onChange,
  helperText,
  errorMessage,
  value,
  isLoading,
  debouncedOnChangeHandler,
  required,
}: Props) => {
  const debouncedSave = useDebouncedSave(async (value: string) => {
    if (debouncedOnChangeHandler) await debouncedOnChangeHandler(value);
  });

  return (
    <FormControl isRequired={required} isInvalid={errorMessage !== undefined}>
      <FormLabel htmlFor={name}>
        {label} {isLoading && <Spinner size="xs" />}
      </FormLabel>
      <Textarea
        id={name}
        onChange={(e) => {
          onChange(e.target.value);
          debouncedSave(e.target.value);
        }}
        value={value === undefined ? "" : value}
      />
      <FormHelperText>{helperText}</FormHelperText>
      <FormHelperText color="red.500">{errorMessage}</FormHelperText>
    </FormControl>
  );
};
